<template>
    <div>
        <div v-if="loading">
            <div class="spinner"></div>
        </div>

        <div v-else-if="state === 'error'" class="alert--error" >
            <span v-for="err in errors" :key="err"> {{ err }} </span>
        </div>

        <form v-if="!loading" class="form" @submit.prevent="searchClient">
            <slot name="header"></slot>

            <div :class="wrapperClass">
                <div class="form__item">
                    <i class="form__icon icons icon-briefcase"></i>
                    <vue-select label="name" :options="organisations" v-model="organisation" class="form__select" :class="{ 'has-value': organisation }" >
                        <template slot="no-options">{{$t('forms.common.no_results')}}</template>
                    </vue-select>
                    <label class="form__label">{{$t('forms.common.labels.organisation')}}</label>
                </div>

                <div class="form__item">
                    <i class="form__icon icons icon-envelope"></i>
                    <input v-model="email" class="form__input--text" type="email" autocomplete='email'  :class="{ 'has-value': email }" />
                    <label class="form__label">{{$t('forms.common.labels.email')}}</label>
                </div>
            </div>

            <slot name="buttons" :isNextDisabled="isNextDisabled">
                <div class="form__buttons">
                    <button type="submit" class="form__button button--cta" :class="{disabled: isNextDisabled}" :disabled="isNextDisabled">{{$t('common.search')}}</button>
                    <div class="spinner--small" v-if="state == 'loading'"></div>
                </div>
            </slot>

        </form>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Organisation from '@/models/Organisation';
    import Client from '@/models/Client';
    import { Component, Prop } from 'vue-property-decorator';

    @Component
    export default class SearchClientForm extends Vue {

        @Prop({ type: Array | String, default() {
            return [];
        } })
        wrapperClass;

        email = '';
        organisation = null;

        state = 'input';
        errors = [];

        get loading () {
            return this.$store.state.trajectory_resources.loading || this.state === 'loading';
        }

        get organisations() {
            return this.$store.state.trajectory_resources.organisations;
        }

        get isNextDisabled() {
            return !this.organisation || !this.organisation.id || !this.email;
        }

        // Can also implement searching in the following way if the organisation lists becomes too big.
        // Requires a query endpoint for that.
        // onOrganisationSearch(search, loading) {
        //     loading(true);
        //     this.search(loading, search, this);
        // }

        // search = (loading, search, vm) =>  {
        //     Organisation.collection().then(orgs => {
        //         vm.organisations = orgs;
        //         loading(false);
        //     });
        // };

        /**
         * Search for a client using the emaila and the organisation.
         */
        searchClient() {
            this.errors = [];
            this.state = 'loading';

            let data = {
                email: this.email,
                organisation_id: this.organisation.id
            };

            this.axios.post('/client/search', data)
                .then(
                    res => {
                        if (res.data.state === 'type_mismatch' || res.data.state === 'organisation_mismatch') {
                            this.state = 'error';
                            this.errors = [this.$t(`forms.search_client.errors.${res.data.state}`)];
                        } else if (res.data.state === 'nonexistant') {
                            let client = new Client();
                            client.fill(data);
                            this.$emit('create-client', {client, organisation: this.organisation});
                        } else if (res.data.state === 'ok') {
                            let client = new Client();
                            client.fill(res.data.account);
                            client.searched_organisation_id = data.organisation_id;
                            client.searched_email = data.email;
                            this.$emit('found-client', {client, organisation: this.organisation});
                        }
                    })
                .catch(
                    err => {
                        if (err.status === 422) {
                            this.state = 'error';
                            this.errors = err.errors;
                        } else {
                            this.state = 'error';
                            this.errors = [this.$t('common.unknown_error')];
                            throw err;
                        }
                    });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/dashboard/SearchClientForm.vue